export default __webpack_public_path__ + "static/media/no-photo.cf293560.svg";